export const QUERY_KEY = {
  PROFILE: "PROFILE",
  LIST_USER: "LIST_USER",
  LIST_RESERVE: "LIST_RESERVE",
  LIST_USER_SEARCH: "LIST_USER_SEARCH",
  AUTH_TOKEN: "AUTH_TOKEN",
};
